module.exports = __webpack_public_path__ + "static/media/YM70_5.56686bae.jpg";